import { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import styles from "../assets/css/DriverRequest.module.css";
import Header from "../components/Header";
import List from "../components/List";
import { BASE_URL } from "../constants/constants";

const DriverRequest = () => {
  const navigate = useNavigate();
  const [requests, setRequests] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const itemsPerPage = 15;
  const [phoneNumber, setPhoneNumber] = useState("");
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [totalDriversCount, setTotalDriversCount] = useState(0);
  const token = localStorage.getItem("token");

  const headers = {
    Authorization: `Bearer ${token}`,
  };

  const getRequests = (page = 1) => {
    const params = {
      page: page,
      limit: itemsPerPage,
      isConfirmed: false,
      isActive: false,
    };

    if (phoneNumber) params.phoneNumber = phoneNumber;
    if (firstName) params.firstName = firstName;
    if (lastName) params.lastName = lastName;

    axios
      .get(`${BASE_URL}/v0/drivers`, {
        headers,
        params,
      })
      .then((response) => {
        setRequests(response.data.result.Drivers);
        setTotalPages(response.data.result.TotalPages);
        setTotalDriversCount(response.data.result.DriversCount);
      })
      .catch((error) => {
        console.error(
          "There was an error fetching the driver requests!",
          error
        );
      });
  };

  useEffect(() => {
    getRequests(currentPage);
  }, [currentPage, phoneNumber, firstName, lastName]);

  const handlePageChange = (newPage) => {
    if (newPage >= 1 && newPage <= totalPages) {
      setCurrentPage(newPage);
    }
  };

  return (
    <div>
      <Header />
      <div className={styles.container}>
        <List />
        <div className={styles.container1}>
          <div className={styles.box}>
            <div className={styles.text}>
              Запросы <span>{totalDriversCount}</span>
            </div>
          </div>
          <div className={styles.searchBlock}>
            <input
              className={styles.search}
              type="text"
              placeholder="Имя"
              value={firstName}
              onChange={(e) => setFirstName(e.target.value)}
            />
            <input
              className={styles.search}
              type="text"
              placeholder="Фамилия"
              value={lastName}
              onChange={(e) => setLastName(e.target.value)}
            />
            <input
              className={styles.search}
              type="text"
              placeholder="+7"
              value={phoneNumber}
              onChange={(e) => setPhoneNumber(e.target.value)}
            />
          </div>
          <div className={styles.container2}>
            {requests.map((el) => (
              <div key={el.driverID}>
                <div className={styles.block}>
                  <div className={styles.name}>
                    {el.firstName} {el.lastName}
                  </div>
                  <div className={styles.box1}>
                    <div className={styles.phone}>{el.phoneNumber}</div>
                    <button
                      onClick={() => navigate(`/driverRequest/${el.driverID}`)}
                      className={styles.adminbtn}
                    >
                      <div className={styles.description}>Подробнее</div>
                      <img
                        className={styles.nexticon}
                        src="/images/Vector.svg"
                        alt="next icon"
                      />
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </div>
          <div className={styles.block2}>
            <div className={styles.paginate}>
              <div className={styles.box3}>
                <img
                  className={styles.paginationicons}
                  src="/images/left.svg"
                  alt="left icon"
                  onClick={() => handlePageChange(currentPage - 1)}
                />
              </div>
              <div className={styles.page}>
                {currentPage} / {totalPages}
              </div>
              <div className={styles.box4}>
                <img
                  className={styles.paginationicons}
                  src="/images/right.svg"
                  alt="right icon"
                  onClick={() => handlePageChange(currentPage + 1)}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DriverRequest;
